export default __webpack_public_path__ + "static/heroSectionBg-af238c11d7325f4851ed9fc8cd7015d1.png";